import { useEffect, useState } from "react"
import { useLocation, useParams } from "react-router-dom"
import { Activity } from "../../../models/activity.model"
import { CollectionQuery, Order } from "../../../models/collection.model"
import {
  EntityConfig,
  entityViewMode,
} from "../../../models/entity-config.model"
import { User } from "../../../models/user.model"
import EntityList from "../../../shared/component/entity-list/entity-list.component"
import {
  useLazyGetAccountsQuery,
  useLazyGetActivitiesQuery,
} from "../store/activity.query"
import { Employee } from "../../../models/employee.model"
import { motion } from "framer-motion"
import StatCard from "../../dashboard/component/stat-cart"
import { AlertTriangle, DollarSign, Package, TrendingUp } from "lucide-react"
import { LoadingOverlay } from "@mantine/core"
import { dateFormat } from "../../../shared/utility/date-format/date-format"
import { useTranslation } from "react-i18next"
export default function ActivityPage() {
  const params = useParams()
  const location = useLocation()
  const [viewMode, setViewMode] = useState<entityViewMode>("list")
  const [collection, setCollection] = useState<CollectionQuery>({
    skip: 0,
    top: 10,
    orderBy: [{ field: "createdAt", direction: "desc" }],
  })

  const [getActivities, activities] = useLazyGetActivitiesQuery()
  const [getAccounts, accounts] = useLazyGetAccountsQuery()
  const { t } = useTranslation()
  useEffect(() => {
    getActivities(collection)
  }, [collection])

  useEffect(() => {
    if (params?.id !== undefined) {
      setViewMode("detail")
    } else {
      setViewMode("list")
    }
  }, [setViewMode, params?.id, location])

  const data: Activity[] | undefined = activities.data?.data
  const config: EntityConfig<Activity> = {
    primaryColumn: { key: "action", name: "Action" },
    showDetail: false,
    detailUrl: "detail",
    rootUrl: "/activity",
    identity: "id",
    name: "action",
    visibleColumn: [
      { key: "action", name: "Action" },
      {
        key: ["user", "name"],
        name: "Done By",
        render(value) {
          return value.user.name
        },
      },
      { key: "modelName", name: "Acted On" },
      {
        key: "createdAt",
        name: "Date/Time",
        render(value) {
          return dateFormat(value.createdAt)
        },
      },
    ],
  }

  return (
    <main className="max-w-7xl mx-auto py-6 px-4 lg:px-8 mt-16">
      <LoadingOverlay visible={activities.isFetching} />

      {/* <motion.div
        className='grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4 mb-8'
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
      >

        <StatCard name='Total Products' icon={Package} value='$12,345' color='#6366F1' />
        <StatCard name='Top Selling' icon={TrendingUp} value='1,234' color='#8B5CF6' />
        <StatCard name='Low Stock' icon={AlertTriangle} value='567' color='#EC4899' />
        <StatCard name='Total Revenue' icon={DollarSign} value='12.5%' color='#10B981' />

      </motion.div> */}
      <EntityList
        viewMode={viewMode}
        title={t("activities")}
        total={activities?.data?.count}
        itemsLoading={activities.isFetching || accounts.isFetching}
        config={config}
        items={data}
        showNewButton={false}
        initialPage={1}
        defaultPageSize={10}
        pageSize={[10, 15, 20]}
        collectionQuery={collection}
        onPaginationChange={(skip: number, top: number) => {
          if (collection.skip !== skip || collection.top !== top) {
            setCollection({ ...collection, skip: skip, top: top })
          }
        }}
        onSearch={(data: any) => {
          getAccounts({
            searchFrom: ["name", "phoneNumber"],
            search: data,
          }).then((response: any) => {
            const f: any = []
            response?.data?.data?.map((r: User | Employee) => {
              f.push(r.id)
            })
            if (f.length > 0) {
              setCollection({
                ...collection,
                filter: [[{ field: "userId", operator: "in", value: f }]],
              })
            }
          })
        }}
        onFilterChange={(data: any) =>
          setCollection({ ...collection, filter: data })
        }
        onOrder={(data: Order) =>
          setCollection({ ...collection, orderBy: [data] })
        }
      />
    </main>
  )
}
